// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_hv-6";
export var emphasizeQuantity = "_hv-3";
export var flatBottomCorners = "_hv-5";
export var productImage = "_hv-0";
export var quantityContainer = "_hv-2";
export var tooltip = "_hv-1";
export var wrapAndEllipsesOverflow = "_hv-4";